


const collectionSwiperVal = document.querySelector('.article-collection-template.swiper .image-list');
const journalVal = document.querySelector('.drmvsn-article-journal');

if(collectionSwiperVal !== null) {
 const collectionSwiper = new Swiper(".article-collection-template.swiper", {
    slidesPerView:  30,
    pagination: {
        el: ".article-collection-template .swiper-pagination",
        type: "fraction",
    },
    navigation: {
        nextEl: ".article-collection-template .swiper-button-next",
        prevEl: ".article-collection-template .swiper-button-prev",
    },
    breakpoints: {
      990: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        centeredSlides: true,
        // slidesPerView: 2,
        // slidesPerGroup: 2,
        // spaceBetween: 10,
      },
    }
  }); 
}

// if(!journalVal) return;
